import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[640px] md:min-h-[760px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20aerial%20view%20of%20a%20lush%20championship%20golf%20course%20at%20golden%20hour%2C%20immaculate%20rolling%20fairways%20with%20deep%20emerald%20greens%2C%20mature%20pine%20trees%20along%20the%20perimeter%2C%20soft%20golden%20warm%20sunlight%20casting%20long%20shadows%2C%20artistic%20painterly%20editorial%20style%2C%20cinematic%20depth%20of%20field%2C%20moody%20atmospheric%20background%20for%20bold%20overlay%20text%2C%20peaceful%20serene%20composition&width=2000&height=1200&seq=handicalc-hero-bg-v2&orientation=landscape"
        alt="Golf course at sunset"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full mx-auto max-w-content px-4 md:px-6 py-20 md:py-28 text-center">
        {/* Challenge Banner */}
        <Link
          to="/challenge"
          className="group block mx-auto mb-10 max-w-3xl"
        >
          <div className="relative overflow-hidden rounded-xl bg-background-950/80 backdrop-blur-sm border-l-[6px] border-accent-500 hover:border-accent-400 transition-colors px-6 py-5 md:px-8 md:py-6 cursor-pointer">
            {/* Subtle accent glow behind */}
            <div className="absolute -top-10 -right-10 w-32 h-32 bg-accent-500/10 rounded-full blur-2xl pointer-events-none"></div>

            <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 shrink-0 shadow-lg shadow-accent-500/20">
                <i className="ri-trophy-line text-foreground-950 text-xl"></i>
              </span>
              <div className="flex-1 text-left">
                <p className="text-background-50 text-base md:text-lg font-semibold leading-snug">
                  The Handicalc Challenge — win a place at the Dan Grieve Invitational
                </p>
                <p className="mt-1 text-sm text-background-100/70">
                  27 August 2026 · Free to enter · No purchase necessary
                </p>
              </div>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50 hover:bg-background-100 text-background-950 text-sm font-semibold shrink-0 transition-colors whitespace-nowrap">
                Learn more <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </div>
        </Link>

        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur border border-background-50/25 text-background-50 text-xs md:text-sm font-medium">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
          Built for golfers &amp; clubs worldwide
        </span>

        <h1 className="mt-6 font-heading font-bold text-background-50 text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05] max-w-4xl mx-auto">
          <a href="#hero">
            Calculate Golf Shot Allowances in Seconds
          </a>
        </h1>

        <p className="mt-6 text-base md:text-lg text-background-100/90 max-w-2xl mx-auto leading-relaxed">
          Search your course, pick a tee, choose a format and enter your handicap. HANDICALC® instantly
          returns the correct WHS™ shot allowances — perfect for competitions, fourballs, tours and match play.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/calculator"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer transition-colors shadow-sm"
          >
            <i className="ri-calculator-line"></i>
            Open HANDICALC®
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/how-it-works"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-background-50/10 hover:bg-background-50/20 backdrop-blur border border-background-50/30 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-play-circle-line"></i>
            See how it works
          </Link>
        </div>

        <div className="mt-5 flex items-center justify-center gap-3">
          <span className="hidden sm:block w-8 h-px bg-background-50/25"></span>
          <span className="text-[11px] md:text-xs text-background-100/70 whitespace-nowrap">or download the app</span>
          <span className="hidden sm:block w-8 h-px bg-background-50/25"></span>
        </div>

        <div className="mt-3 flex items-center justify-center gap-4">
          <a
            href="https://apps.apple.com/gb/app/handicalc/id6757720525"
            target="_blank"
            rel="noopener noreferrer"
            className="w-[140px] h-[48px] cursor-pointer transition-transform hover:scale-105"
            aria-label="Download HANDICALC on the App Store"
          >
            <img
              src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
              alt="Download on the App Store"
              className="w-full h-full object-contain"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.wnapp.id1773163661064"
            target="_blank"
            rel="noopener noreferrer"
            className="w-[140px] h-[48px] cursor-pointer transition-transform hover:scale-105"
            aria-label="Get HANDICALC on Google Play"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/edited_714094e88e03320dda08007cdcd15bfb_2a3910ca.jpg"
              alt="Get it on Google Play"
              className="w-full h-full object-contain"
            />
          </a>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
          {[
            { v: "UK, Ireland & more", l: "Coverage" },
            { v: "All major", l: "Playing formats supported" },
            { v: "<1s", l: "Average calculation" },
            { v: "100%", l: "WHS™ aligned" },
          ].map((s) => (
            <div key={s.l} className="flex flex-col items-center justify-center text-center rounded-lg bg-background-50/10 backdrop-blur border border-background-50/15 px-3 py-4 md:px-5 md:py-5">
              <div className="font-heading font-bold text-background-50 text-2xl md:text-3xl">{s.v}</div>
              <div className="mt-1 text-[11px] md:text-xs text-background-100/85 leading-snug">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}